import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appDisableRightClick]'
})
export class DisableRightClickDirective implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit(): void {
    const iframe = this.el.nativeElement;

    // Listen for the iframe's `load` event
    this.renderer.listen(iframe, 'load', () => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDoc) {
        this.disableRightClick(iframeDoc);
      }
    });
  }

  private disableRightClick(doc: Document): void {
    doc.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    });
  }
}
